import { Form, Head, router, usePage } from "@inertiajs/react"
import { FcGoogle } from "react-icons/fc"

import InputError from "@/components/input-error"
import TextLink from "@/components/text-link"
import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { Separator } from "@/components/ui/separator"
import AuthLayout from "@/layouts/auth-layout"
import { newIdentityPasswordResetPath, signInPath, signUpPath } from "@/routes"

export default function Login() {
  const { props } = usePage()
  // eslint-disable-next-line react/prop-types
  const isMobileApp = (props.app as { mobile_app?: boolean })?.mobile_app

  const handleGoogleLogin = async () => {
    if (isMobileApp) {
      const { handleNativeGoogleLogin } = await import("@/lib/native-auth")
      await handleNativeGoogleLogin()
    } else {
      window.location.assign("/auth/google")
    }
  }
  return (
    <AuthLayout
      title="Inicia sesión en tu cuenta"
      description="Ingresa tu email y contraseña para acceder"
    >
      <Head title="Iniciar Sesión" />
      <Form
        method="post"
        action={signInPath()}
        resetOnSuccess={["password"]}
        className="flex flex-col gap-6"
      >
        {({ processing, errors }) => (
          <>
            <div className="grid gap-6">
              <div className="grid gap-2">
                <Label htmlFor="email">Correo electrónico</Label>
                <Input
                  id="email"
                  name="email"
                  type="email"
                  required
                  tabIndex={1}
                  autoComplete="email"
                  placeholder="correo@ejemplo.com"
                />
                <InputError message={errors.email} />
              </div>

              <div className="grid gap-2">
                <div className="flex items-center">
                  <Label htmlFor="password">Contraseña</Label>
                  <TextLink
                    href={newIdentityPasswordResetPath()}
                    className="ml-auto text-sm"
                    tabIndex={5}
                  >
                    ¿Olvidaste tu contraseña?
                  </TextLink>
                </div>
                <Input
                  id="password"
                  type="password"
                  name="password"
                  required
                  tabIndex={2}
                  autoComplete="current-password"
                  placeholder="Contraseña"
                />
                <InputError message={errors.password} />
              </div>

              <Button
                type="submit"
                className="text-chart-5 bg-card mt-[6px] mb-[11px] h-[49px] w-full rounded-[14px] px-[24px] py-[14px] text-[15px] leading-[23px] font-medium tracking-[0.45px] shadow-[0_0_8px_#00000029]"
                disabled={processing}
              >
                {processing ? "Iniciando sesión..." : "Ingresar"}
              </Button>
            </div>

            <div className="space-y-4">
              <Separator />

              <Button
                type="button"
                variant="default"
                className="my-[17px] h-[49px] w-full rounded-[14px] text-[15px] leading-[23px] font-medium tracking-[0.45px] text-white"
                onClick={() => {
                  void handleGoogleLogin()
                }}
              >
                <div className="bg-card mr-2 flex h-[32px] w-[32px] items-center justify-center rounded-full">
                  <FcGoogle className="size-7" />
                </div>
                Ingresar con Google
              </Button>

              <div className="text-chart-5 text-center text-[13px] leading-[20px] font-normal tracking-[0.2px]">
                ¿No tienes cuenta?{" "}
                <button
                  type="button"
                  onClick={() => {
                    router.visit(signUpPath())
                  }}
                  className="text-chart-3 text-center text-[12px] leading-[18px] font-medium tracking-[0.18px]"
                >
                  Regístrate aquí
                </button>
              </div>
            </div>
          </>
        )}
      </Form>
    </AuthLayout>
  )
}
